<template>
  <div class="manual-checkin-form">
    <h3 class="form-title">手動報到</h3>
    <div class="form-group">
      <label>姓名</label>
      <input
        v-model="formData.name"
        type="text"
        class="form-control"
        placeholder="請輸入姓名"
      />
    </div>
    <div class="form-group">
      <label>手機</label>
      <input
        v-model="formData.phone"
        type="tel"
        class="form-control"
        placeholder="請輸入手機號碼"
      />
    </div>
    <div class="form-actions">
      <button
        class="s-btn s-btn-secondary action-button"
        @click="handleCancel"
      >
        取消
      </button>
      <button
        class="s-btn s-btn-primary action-button"
        @click="handleSubmit"
        :disabled="!canSubmit"
      >
        確認
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ManualCheckinForm",
  data() {
    return {
      formData: {
        name: '',
        phone: ''
      }
    };
  },
  computed: {
    canSubmit() {
      return this.formData.name.trim() !== '' &&
             this.formData.phone.trim() !== '' &&
             /^[0-9]{10}$/.test(this.formData.phone);
    }
  },
  methods: {
    handleSubmit() {
      if (!this.canSubmit) return;

      this.$emit('submit', {
        name: this.formData.name,
        phone: this.formData.phone
      });
    },
    handleCancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss" scoped>
.manual-checkin-form {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
}

.form-title {
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 24px;
  color: #2c2c2e;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box;
}

.form-control:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.form-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
}

.action-button {
  flex: 1;
  max-width: 150px;
}
</style>
